import {JsonProperty} from '@hyperloris/tyson';
import {DateTime} from 'luxon';

export class SrcMappingExchange {

  @JsonProperty()
  id: number;

  @JsonProperty()
  sourceCode: string | undefined;

  @JsonProperty()
  crystalExchangeCode: string | undefined;

  @JsonProperty()
  sourceExchangeCode: string | undefined;

  @JsonProperty()
  source: string | undefined;

  @JsonProperty()
  modificationDate: DateTime = DateTime.now();

}
